import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

const TOKEN_KEY = 'dozor_jwt'
const USERNAME_KEY = 'dozor_username'

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | null>(null)
  const username = ref<string | null>(null)

  const isAuthenticated = computed(() => token.value !== null)

  function hydrate() {
    token.value = sessionStorage.getItem(TOKEN_KEY)
    username.value = sessionStorage.getItem(USERNAME_KEY)
  }

  function setAuth(t: string, u: string) {
    token.value = t
    username.value = u
    sessionStorage.setItem(TOKEN_KEY, t)
    sessionStorage.setItem(USERNAME_KEY, u)
  }

  function clear() {
    token.value = null
    username.value = null
    sessionStorage.removeItem(TOKEN_KEY)
    sessionStorage.removeItem(USERNAME_KEY)
  }

  return { token, username, isAuthenticated, hydrate, setAuth, clear }
})
